import React from 'react';

export default function PageHero({ eyebrow, lead, title, subtitle, image }) {
  return (
    <section className="relative flex min-h-[58vh] items-center overflow-hidden pt-28">
      <div className="absolute inset-0">
        <img src={image} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-farmway-green/85 via-farmway-green/80 to-farmway-green" />
        <div className="absolute inset-0 bg-farmway-green/30" />
      </div>
      <div className="container-fw relative py-16">
        <span className="eyebrow animate-fade-up">{eyebrow}</span>
        <h1 className="mt-5 animate-fade-up" style={{ animationDelay: '80ms' }}>
          {lead && (
            <span className="block font-body text-2xl font-light tracking-tight text-farmway-cream/70 sm:text-3xl">
              {lead}
            </span>
          )}
          <span className="display-xl block text-5xl text-farmway-cream sm:text-6xl lg:text-7xl">{title}</span>
        </h1>
        {subtitle && (
          <p className="mt-6 max-w-2xl animate-fade-up text-lg leading-relaxed text-farmway-cream/75" style={{ animationDelay: '160ms' }}>
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
